import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
//import InputRange from 'react-input-range';
import { useTranslation } from 'react-i18next'

//import Dropdown from '../dropdown'
//import { Checkbox } from '../checkbox';
import NearByButton from './nearByButton'
import { topCategories } from '../../store/global/tourCategories'

export const NearByNav = withRouter((props: any) => {
    const [showMenu, setShowMenu] = useState(false)
    const { t } = useTranslation()
    const { history, tour } = props;

    const handleShowMenu = (event: React.MouseEvent) => {
        event.preventDefault();
        setShowMenu(!showMenu)
    }

    const handleCloseMenu = () => setShowMenu(false)
    const goBack = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault()
        history.goBack()
    }

    return (
        <nav className="near-by-nav secound-nav clearfix">
            <a href ="/" className="cta cta-back fl m-tb5" onClick={goBack}>
                <img src="/images/icons/icon-back.png" alt="back" />{t('Back to Result')}
            </a>
            <div className="near-by-placeholder">
                <span className="nav-item" onClick={handleShowMenu}>
                    <img src="/images/icons/hamburger.png" alt="Menu" /> {t('Near By')}
                    </span>
            </div>
            <ul style={{ display: showMenu ? 'block' : 'none' }}>
                <li className="near-by-label clearfix">
                    <label>
                        {t('Near By')}:
                        </label>
                    <button onClick={handleCloseMenu} className="fr p-r15">
                        <img src="/images/icons/close-icon.png" alt="close" />
                    </button>
                </li>
                {topCategories.map((item) =>
                    <li key={item.name}>
                        <NearByButton
                            isActive={false}
                            topCategory={item}
                            tour={tour}
                        />
                    </li>
                )}

                {/* <li>
                    <Dropdown
                        buttonElements={
                            <span className="nav-item"><img src="/images/icons/small-icon-hotels.png" alt="Hotels" />
                                {t('Hotels')}</span>
                        }
                        dropdownContent={
                            <div className="near-by-picker">
                                <div className="near-by-picker-input">
                                    <h6 className={'clearfix'}>{t('Near By')} <small className="fr">Max. {25}km</small></h6>
                                    <InputRange
                                        maxValue={99}
                                        value={25}
                                        onChange={value => {}}
                                    />
                                </div>
                                <div className="near-by-picker-action clearfix">
                                    <a href="/" className="cta cta-back cta-small">{t('Reset')}</a>
                                    <a href="/near-by-hotel" className="cta fr cta-small">{t('Done')}</a>
                                </div>
                            </div>
                        }
                        showMenu={false}
                        setShowMenu={(show: boolean) => {}}
                    />
                </li>
                <li>
                    <Link to="/" className="nav-item">
                        <img src="/images/icons/small-icon-villas.png" alt="Villas" />
                        {t('Villas')}
                    </Link>
                </li>
                <li>
                    <Link to="/" className="nav-item">
                        <img src="/images/icons/small-icon-flights.png" alt="Flights" />
                        {t('Flights')}
                    </Link>
                </li>
                <li>
                    <Dropdown
                        buttonElements={
                            <span className="nav-item"><img src="/images/icons/small-icon-activities.png" alt="Activities" />
                                {t('Activities')}</span>
                        }
                        dropdownContent={
                            <div className="p-lr15 p-tb15 near-by-picker" style={{ width: '420px' }}>
                                <ul className="small-block-grid-2">
                                    <li className="p-b5">
                                        <Checkbox label={t('Eating & Drinking')} />
                                    </li>
                                    <li className="p-b5">
                                        <Checkbox label={t('Yachts & Marinas')} />
                                    </li>
                                    <li className="p-b5">
                                        <Checkbox label={t('Health & Beauty')} />
                                    </li>
                                    <li className="p-b5">
                                        <Checkbox label={t('Tourist Attractions')} />
                                    </li>
                                    <li className="p-b5">
                                        <Checkbox label={t('Sports & Fun')} />
                                    </li>
                                    <li className="p-b5">
                                        <Checkbox label={t('Cultural & Social')} />
                                    </li>
                                    <li className="p-b5">
                                        <Checkbox label={t('Transportation')} />
                                    </li>
                                    <li className="p-b5">
                                        <Checkbox label={t('Entertainment 18+')} />
                                    </li>
                                    <li className="p-b5">
                                        <Checkbox label={t('Hotels & Holidays')} />
                                    </li>
                                    <li className="p-b5">
                                        <Checkbox label={t('Business And Services')} />
                                    </li>
                                    <li className="p-b5">
                                        <Checkbox label={t('Shopping')} />
                                    </li>
                                    <li className="p-b5">
                                        <Checkbox label={t('Vacation Rentals')} />
                                    </li>
                                </ul>
                            </div>
                        }
                        showMenu={false}
                        setShowMenu={(show: boolean) => {}}
                    />
                </li>
                <li>
                    <Dropdown
                        buttonElements={
                            <span className="nav-item"><img src="/images/icons/small-icon-restaurants.png" alt="Restaurants" />
                                {t('Restaurants')}</span>
                        }
                        dropdownContent={
                            <div className="near-by-picker">
                                <div className="near-by-picker-input">
                                    <h6 className={'clearfix'}>{t('Near By')} <small className="fr">Max. {maxHotelKM}km</small></h6>
                                    <InputRange
                                        maxValue={99}
                                        value={maxHotelKM}
                                        onChange={value => setMaxHotelKM(value as number)}
                                    />
                                </div>
                                <div className="near-by-picker-action clearfix">
                                    <a href="/" className="cta cta-back cta-small">{t('Reset')}</a>
                                    <a href="/near-by-hotel" className="cta fr cta-small">{t('Done')}</a>
                                </div>
                            </div>
                        }
                        showMenu={false}
                        setShowMenu={(show: boolean) => {}}
                    />
                </li>
                <li>
                    <Link to="/" className="nav-item">
                        <img src="/images/icons/small-icon-coupons.png" alt="Coupons" />
                        {t('Coupons')}
                        </Link>
                </li>
                <li>
                    <Link to="/" className="nav-item">
                        <img src="/images/icons/small-icon-jobs.png" alt="Jobs" />
                        {t('Jobs')}
                        </Link>
                </li> */}
            </ul>

        </nav>
    )
})